// extracted by mini-css-extract-plugin
module.exports = {"text":"_3lcIBcXudjty4e9UnQ34Z2","high":"_1tW8xw8WZu07UQotFjjiAf","medium":"_11VR7FyUkO3-nlm-y1XPRJ","low":"_1OIoRSQa1ns2ZGTiViot45"};